'use client';

import { Link } from '@/app_components/common/Link';

interface SurveyProps {
  surveyUrl?: string | null;
}

export const Survey = ({ surveyUrl }: SurveyProps) => {
  if (!surveyUrl) {
    return null;
  }

  return (
    <div
      className='flex flex-col justify-between items-center p-5 border border-[#007B9D] mx-4 relative z-[9] w-full rounded opacity-100 md:flex-row md:mx-auto mb-8 bg-[#F4FAFB]'
      data-cy='survey-container'
    >
      <div
        className='flex flex-col gap-2 w-full opacity-100 mb-5 md:max-w-[80%] md:mb-0 font-[Graphik_Compact] font-normal text-base leading-[140%] tracking-[0px]'
        data-cy='survey-content'
      >
        <h2
          className='text-xl font-bold leading-[130%] tracking-[0px] font-[Inria_Serif]'
          data-cy='survey-heading'
        >
          Your opinion matters!
        </h2>

        <div
          className='text-[#626262] font-normal leading-[140%] tracking-[0px] font-[Graphik_Compact]'
          data-cy='survey-description'
        >
          Please take a moment to share feedback—we're always looking to improve.
        </div>
      </div>
      <Link
        className='bg-[#006885] text-white font-medium text-base leading-4 tracking-[0px] font-[Graphik_Compact] !no-underline rounded-full hover:bg-[#005973] transition-colors w-full md:w-[141px] h-12 flex justify-center items-center'
        data-cy='survey-link'
        href={surveyUrl}
        rel='noopener noreferrer'
        target='_blank'
      >
        Take Survey
      </Link>
    </div>
  );
};
